<template>
  <div class="btn-flex-box" >
    <div style="margin-bottom: 20px;text-align: left;">
      <el-button-group v-if="null != editObj && (null == readonlyTag || false === readonlyTag)">
        <el-button
            :type="dataType === 'detail' ? 'primary' : ''"
            @click="changeType('detail')"
        >
          <span tkey="詳情">{{i18n.tkey("lang_details")}}</span>
        </el-button>
        <el-button
            :type="dataType === 'product' ? 'primary' : ''"
            @click="changeType('product')"
        >
          <span tkey="參展產品">{{i18n.tkey("lang_exhibited_products")}}</span>
        </el-button>
      </el-button-group>
    </div>
  </div>
    <div  v-if="dataType==='detail'"  v-loading="loading">
        <ul class="data-ul">
            <li v-if="null != editObj">
                <span tkey="展館號">{{i18n.tkey("lang_hall_num")}}</span> : {{editObj.addinfo1}}-{{editObj.addinfo2}}
                <el-button type="primary" size="small" @click="clickGoBooth" tkey="前往展臺">{{i18n.tkey("lang_go_booth")}}</el-button>
            </li>

            <li>
                <h4>{{hallObj.recordname}}</h4>
            </li>

            <li>
                <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>
            </li>

<!--            <li>-->
<!--                <span tkey="參展費用">{{i18n.tkey("lang_join_hall_cost")}}</span> : <span>{{hallObj.addinfo9}} HKD</span>-->
<!--            </li>-->

            <li>
                <span tkey="展館報名時間">{{i18n.tkey("lang_hall_appy_time")}}</span> : <span>{{hallObj.addinfo1}}-{{hallObj.addinfo2}}</span>
            </li>

            <li>
                <span tkey="展館有效時間">{{i18n.tkey("lang_hall_visible_time")}}</span> : <span>{{hallObj.addinfo3}}-{{hallObj.addinfo4}}</span>
            </li>

            <li>
                <span tkey="展館描述">{{i18n.tkey("lang_hall_des")}}</span> : <span>{{hallObj.addinfo7}}</span>
            </li>

            <li class="prevew-img-box">
<!--                <span tkey="對應圖片展示">{{i18n.tkey("lang_img_position_display")}}</span>-->
                <img :class="scaleImgIndex == 1 ? 'hall-preview-img-full' : 'hall-preview-img'" :src="hall_position_preview_src_1" @click="changeScaleImgIndex(1)" v-show="scaleImgIndex == null || scaleImgIndex == 1">
                <img :class="scaleImgIndex == 2 ? 'hall-preview-img-full' : 'hall-preview-img'" :src="hall_position_preview_src_2" @click="changeScaleImgIndex(2)" v-show="scaleImgIndex == null || scaleImgIndex == 2">
            </li>

            <li>
                <span class="notice-span" tkey="註:如不上傳圖片則不顯示對應位置的廣告牌">{{i18n.tkey("lang_upload_adv_img_notice")}}</span>
            </li>

            <li v-show="viewPart == 'des'">
                <el-button @click="cancelEdit" style="margin-bottom: 20px" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>

<!--                <ckeditorComponent v-model="inputCompanyDes" style="height: 300px" />-->

                <div style="margin-top: 20px; text-align: center;">
                    <el-button type="primary" @click="saveEdit" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
                </div>
            </li>

            <li v-show="viewPart == 'info'">
                <el-row :gutter="20" style="margin: 0">
                    <el-col :span="12" class="img-box">
                        <span tkey="店鋪招牌0">{{i18n.tkey("lang_shop_name_pad_1")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>1000*200</span>)
                        <br>
                        <uploadImg v-model="shopSetting.img0" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img0') }" @deleteImg="deleteAdvImg('img0')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                    </el-col>

                    <el-col :span="12" class="img-box">
                        <span tkey="公司簡介">{{i18n.tkey("lang_company_detail_1")}}</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)

                      <el-button type="primary" plain @click="goDesEdit" :disabled="readonlyTag" tkey="編輯簡介(文字轉圖片)">{{i18n.tkey("lang_edit_detail_text_to_photo")}}</el-button>
                        <br>
                        <uploadImg v-show="true" v-model="shopSetting.img1" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img1') }" @deleteImg="deleteAdvImg('img1')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                        <br>
                        <el-input v-model="addinfo16"></el-input>
                    </el-col>

                    <el-col :span="24">
                        <pageTitle :titleText="i18n.tkey('lang_Honors_and_Certificates')" style="margin-top: 15px" />
                    </el-col>

                    <el-col :span="12" class="img-box">
                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 1</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)
                        <br>
                        <uploadImg v-model="shopSetting.img4" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img4') }" @deleteImg="deleteAdvImg('img4')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                    </el-col>

                    <el-col :span="12" class="img-box">
                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 2</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)
                        <br>
                        <uploadImg v-model="shopSetting.img5" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img5') }" @deleteImg="deleteAdvImg('img5')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                    </el-col>

                    <el-col :span="24">
                        <el-collapse>
                            <el-collapse-item :title="i18n.tkey('lang_more_img')" name="1">
                                <el-row :gutter="20" style="margin: 0">
                                    <el-col :span="12" class="img-box">
                                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 3</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*600</span>)
                                        <br>
                                        <uploadImg v-model="shopSetting.img2" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img2') }" @deleteImg="deleteAdvImg('img2')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                                    </el-col>

                                    <el-col :span="12" class="img-box">
                                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 4</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)
                                        <br>
                                        <uploadImg v-model="shopSetting.img3" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img3') }" @deleteImg="deleteAdvImg('img3')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                                    </el-col>

                                    <el-col :span="12" class="img-box">
                                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 5</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)
                                        <br>
                                        <uploadImg v-model="shopSetting.img6" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img6') }" @deleteImg="deleteAdvImg('img6')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                                    </el-col>

                                    <el-col :span="12" class="img-box">
                                        <span tkey="圖">{{i18n.tkey("lang_img_text_1")}} 6</span>&nbsp;(<span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>600*800</span>)
                                        <br>
                                        <uploadImg v-model="shopSetting.img7" :readonlyTag="readonlyTag" @selectComplete="(base64) => { uploadAdvImg(base64, 'img7') }" @deleteImg="deleteAdvImg('img7')" :sizeLimit="300" :useBtn="false" :width="150" :height="150" :imgStyle="{'object-fit': 'scale-down'}" />
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </el-collapse>
                    </el-col>

<!--                    <el-col :span="24">-->
<!--                        <pageTitle :titleText="i18n.tkey('lang_exhibited_products')" style="margin-top: 15px" />-->
<!--                    </el-col>-->

<!--                    <el-col :span="24">-->

<!--                    </el-col>-->

<!--                    <el-col :span="24">-->
<!--                        <pageTitle :titleText="i18n.tkey('lang_select_join_hall_material')" style="margin-top: 20px" />-->
<!--                    </el-col>-->

<!--                    <el-col :span="24">-->
<!--                        <hallMaterialEditor ref="hallMaterialEditorDom" :hallId="hallObj.id" :readonlyTag="readonlyTag" />-->
<!--                    </el-col>-->

                    <el-col :span="24" class="img-box operation-box" v-if="true != readonlyTag">
                        <el-button type="success" size="large" v-if="null == editObj" @click="clickAdd" tkey="提交申請">{{i18n.tkey("lang_submit_apply")}}</el-button>
                        <el-button type="primary" size="large" v-if="null != editObj" @click="clickSave" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
                    </el-col>

<!--                    <el-col :span="24" class="img-box operation-box" v-if="true == readonlyTag">-->
<!--                        <el-button size="large" @click="clickGoBooth" tkey="前往展臺">{{i18n.tkey("lang_go_booth")}}</el-button>-->
<!--                    </el-col>-->
                </el-row>
            </li>
        </ul>

        <paypalForm v-if="null != payObj" :formObj="payObj"/>

        <hallCompanyImgGenerator v-if="null != generateImgObj" :obj="generateImgObj" @success-complete="generateImgCallback" />
    </div>

    <div v-if="dataType==='product'" v-loading="loading" >
      <pageTitle :titleText="i18n.tkey('lang_exhibited_products')" />
      <hallProductEditor
          v-if="dataType === 'product'"
          :hallObj="editObj.additionalrecord14"
          :companycode="editObj.companycode"
      />
    </div>
</template>

<script setup>
    import uploadImg from "@/components/shopopee/form/uploadImg"
    import {inject, ref, onMounted, toRef, getCurrentInstance, onBeforeMount, computed} from "vue";
    import paypalForm from "@/components/shopopee/form/paypalForm"
    import hallCompanyImgGenerator from "@/components/shopopee/hall/hallCompanyImgGenerator"
    import pageTitle from "@/components/shopopee/common/pageTitle"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";
    import record15Api from "@/request/record15Api";
    import {useUserinfo} from "@/stores/userinfo";
    import boApi from "@/request/boApi";
    import hallProductEditor from "@/components/shopopee/hallManager/hallProductEditor.vue";

    library.add(faLocationDot)

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })
    const { goShopHallPosition } = inject('threeHallFunc', { goShopHallPosition: () => { jumpToHall() } })

    const shopCompany = ref({})

    const props = defineProps(["editObj", "hallObj", "readonlyTag"])
    const emits = defineEmits(["addComplete", "editComplete"])
    const staticPath = process.env.BASE_URL

    const { proxy } = getCurrentInstance()

    const reload = inject("reload");

    const loading = ref(false)
    const addinfo16 = ref("")
    const dataType = ref("detail")

    // const hallMaterialEditorDom = ref(null)

    //展臺預覽圖片1
    const hall_position_preview_src_1 = computed(() => {
        let url = staticPath + 'static/images/hall_preview_img_1_en.jpg'

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            url = staticPath + 'static/images/hall_preview_img_1_zh.jpg'
        }

        return url
    })
    //展臺預覽圖片1
    const hall_position_preview_src_2 = computed(() => {
        let url = staticPath + 'static/images/hall_preview_img_2_en.jpg'

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            url = staticPath + 'static/images/hall_preview_img_2_zh.jpg'
        }

        return url
    })

    const countryname = computed(() => {
        let name = props.hallObj.country.countryname

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.hallObj.country.countryname2
        }

        return name
    })

    const scaleImgIndex = ref(null)

    //参展记录中的公司描述
    const companyDesText = ref("")
    //用户输入的公司描述
    const inputCompanyDes = ref("")


    const shopSetting = ref({
        img0: null,
        img1: null,
        img2: null,
        img3: null,
        img4: null,
        img5: null,
        img6: null,
        img7: null,
    })

    let editShopSetting = {
        img0: null,
        img1: null,
        img2: null,
        img3: null,
        img4: null,
        img5: null,
        img6: null,
        img7: null,
    }

    //创建订单使用的参数
    const payObj = ref(null)

    //生成图片的数据对象
    const generateImgObj = ref(null)
    //生成图片成功后的回调方法
    let screenShotCallbackFunc = null

    //當前頁面的顯示內容
    const viewPart = ref("info")

    function clickAdd(){
        if (myUtil.isEmpty(shopSetting.value.img0)){
            // myUtil.alertWarning(i18n.tkey("lang_upload_shopname_pad_img_pls"))
            loading.value = true
            screenShotCallbackFunc = clickAdd

            generateImgObj.value = {
                tag: 'companyname',
                companyname: shopCompany.value.companyname
            }

            return
        }

        submitAdd()
    }

    function clickSave(){
        if (myUtil.isEmpty(shopSetting.value.img0)){
            // myUtil.alertWarning(i18n.tkey("lang_upload_shopname_pad_img_pls"))
            loading.value = true
            screenShotCallbackFunc = clickSave

            generateImgObj.value = {
                tag: 'companyname',
                companyname: shopCompany.value.companyname
            }

            return
        }

        submitSave()
    }

    function changeType(mdataType){
      dataType.value = mdataType
    }
    function submitAdd(){
        loading.value = true
        const request = record15Api.submitRecord15
        const params = request.getParams()

        params.additionalrecord15.companycode = shopCompany.value.companycode
        params.additionalrecord15.login = userInfoRef.value.id
        params.additionalrecord15.updatedid = props.hallObj.id
        params.additionalrecord15.addinfo10 = companyDesText.value
        params.additionalrecord15.addinfo12 = JSON.stringify(shopSetting.value)
        params.additionalrecord15.addinfo13 = "0"
        // params.record16List = hallMaterialEditorDom.value.getSelectMaterialList()
        params.record16List = []

        request.send(params, (res) => {
            if (res.code == 200){
                insertHallBo(res.detail)
            }else if (res.code == 201){
                myUtil.alertWarning(i18n.tkey("lang_applied_warning"))
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function submitSave() {
        loading.value = true

        const request = record15Api.editRecord15
        const params = request.getParams()

        params.id = props.editObj.id
        params.addinfo10 = companyDesText.value
        params.addinfo12 = JSON.stringify(shopSetting.value)
        params.addinfo16 = addinfo16.value;
        // params.record16List = hallMaterialEditorDom.value.getSelectMaterialList()
        params.record16List = []

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("editComplete")
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function uploadAdvImg(base64, key){
        if (null != props.editObj){
            if (null != editShopSetting[key]){
                shopSetting.value["deleted" + key] = editShopSetting[key]
                editShopSetting[key] = null
            }
        }

    }

    function deleteAdvImg(key){
        if (null != props.editObj){
            if (null != editShopSetting[key]){
                shopSetting.value["deleted" + key] = editShopSetting[key]
                editShopSetting[key] = null
            }
        }
    }

    function insertHallBo(record15){
        const request = boApi.newHallBo
        const params = request.getParams()

        params.companycode = shopCompany.value.companycode
        params.addinfo3 = userInfoRef.value.login
        params.name = userInfoRef.value.name
        params.telephone = userInfoRef.value.telephone
        params.boproducts = [
            {
                updatedid: props.hallObj.id,
                qty: 1
            }
        ]

        request.send(params, (res) => {
            if (res.code == 200){
                loading.value = false

                if (res.detail.totalsum > 0){
                    const request = record15Api.updateRecord15Commonref
                    const param = request.getParams()

                    param.id = record15.id
                    param.addinfo11 = res.detail.commonref

                    request.send(param, () => {})

                    if (props.hallObj.addinfo9 > 0){
                        payObj.value = {
                            fromtitle: "shopopee_exhibition_" + res.detail.commonref,
                            fromnumber: res.detail.commonref,
                            fromamout: res.detail.totalsum,
                            fromcurr: "HKD"
                        }
                    }

                    setTimeout(() => {
                        myUtil.alertSuccess(i18n.tkey("lang_apply_success"))
                        emits("addComplete")
                    }, 500)
                }else{
                    myUtil.alertSuccess(i18n.tkey("lang_apply_success"))
                    emits("addComplete")
                }
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function clickGoBooth(){
        // if (userInfoRef.value.hid == props.hallObj.id){
        //     goShopHallPosition(props.editObj.addinfo1, props.editObj.addinfo2)
        // }else{
            jumpToHall()
        // }
    }

    function jumpToHall(){
        proxy.$router.push({
            path: `/hall/${props.hallObj.id}/${props.editObj.addinfo1}/${props.editObj.addinfo2}`
        })

        reload()
    }

    function generateImgCallback(obj, base64){
        if (null != obj && null != base64){
            if (obj.tag == "companyname"){
                shopSetting.value.img0 = base64
            }
        }

        generateImgObj.value = null

        if (null != screenShotCallbackFunc){
            screenShotCallbackFunc()
            screenShotCallbackFunc = null
        }
    }

    function goDesEdit(){
        viewPart.value = "des"
        inputCompanyDes.value = companyDesText.value
    }

    function saveEdit(){
        deleteAdvImg('img1')
        shopSetting.value.img1 = null
        viewPart.value = "info"
        companyDesText.value = inputCompanyDes.value
    }

    function cancelEdit(){
        viewPart.value = "info"
        inputCompanyDes.value = companyDesText.value
    }

    function changeScaleImgIndex(index){
        if (scaleImgIndex.value == null){
            scaleImgIndex.value = index
        }else{
            scaleImgIndex.value = null
        }
    }

    onBeforeMount(() => {
        if (null != props.editObj && null != props.editObj.addinfo10){
            companyDesText.value = props.editObj.addinfo10
            inputCompanyDes.value = props.editObj.addinfo10
        }else{
            companyDesText.value = ""
            inputCompanyDes.value = ""
        }

        viewPart.value = "info"
    })

    onMounted(() => {
      console.log(props.editObj)
      if (null != props.editObj &&myUtil.isEmpty(props.editObj.addinfo16)){
        addinfo16.value = props.editObj.addinfo16
      }
        shopCompany.value = getShopCompanyObj()

        if (null != props.editObj && null != props.editObj.addinfo12){
            shopSetting.value = JSON.parse(props.editObj.addinfo12)
            editShopSetting = JSON.parse(props.editObj.addinfo12)
        }
    })
</script>

<style scoped>
    .data-ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
        line-height: 2;
    }

    .img-box {
        margin-bottom: 10px;
    }

    .operation-box {
        text-align: center;
        margin-top: 20px;
    }

    .prevew-img-box {
        /*text-align: right;*/
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .hall-preview-img {
        width: calc(50% - 11px);
        height: 130px;
        object-fit: fill;
        margin-left: 10px;
    }

    .hall-preview-img-full {
        width: calc(100% - 11px);
        height: 260px;
        object-fit: fill;
        margin-left: 10px;
    }

    .icon-span {
        color: #79bbff;
    }

    .notice-span {
        color: #909399;
        font-size: 14px;
    }


    @media screen and (min-width: 520px) {
      .hall-preview-img {
        width: calc(50% - 11px);
        height: 330px;
        object-fit: fill;
        margin-left: 10px;
      }
      .hall-preview-img-full {
        width: calc(100% - 11px);
        height: 460px;
        object-fit: fill;
        margin-left: 10px;
      }
    }
</style>